import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { LayoutDashboard, GitBranch, Shield, Lightbulb, Zap, Search, BarChart3, Layers, Scale, Rocket, Home } from "lucide-react";
import { PROJECTS, PROJECT_CATEGORIES } from "../config/wiseboardConfig";

const dashboardItems = [
  { title: "Dashboard", url: "/wiseboard", icon: LayoutDashboard },
];

export function WiseBoardSidebar() {
  const { state } = useSidebar();
  const collapsed = state === "collapsed";
  const location = useLocation();
  const navigate = useNavigate();
  const { caseId } = useParams();
  const currentPath = location.pathname;

  const isActive = (path: string) => currentPath === path;

  return (
    <Sidebar collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  onClick={() => navigate("/")}
                  className={isActive("/") ? "bg-muted text-primary font-medium" : "hover:bg-muted/50"}
                >
                  <Home className="mr-2 h-4 w-4" />
                  {!collapsed && <span>GainTracker</span>}
                </SidebarMenuButton>
              </SidebarMenuItem>
              {dashboardItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.url)}
                    className={isActive(item.url) ? "bg-muted text-primary font-medium" : "hover:bg-muted/50"}
                  >
                    <item.icon className="mr-2 h-4 w-4" />
                    {!collapsed && <span>{item.title}</span>}
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        {caseId && (
          <>
            <SidebarGroup>
              <SidebarGroupLabel>Case Workflow</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  <SidebarMenuItem>
                    <SidebarMenuButton
                      onClick={() => navigate(`/wiseboard/case/${caseId}`)}
                      className={isActive(`/wiseboard/case/${caseId}`) ? "bg-muted text-primary font-medium" : "hover:bg-muted/50"}
                    >
                      <GitBranch className="mr-2 h-4 w-4" />
                      {!collapsed && <span>Pipeline</span>}
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>

            <SidebarGroup>
              <SidebarGroupLabel>Projects</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {Object.values(PROJECTS).map((project) => {
                    const path = `/wiseboard/case/${caseId}/${project.id.toLowerCase().replace('_', '-')}`;
                    const catInfo = PROJECT_CATEGORIES[project.category];
                    return (
                      <SidebarMenuItem key={project.id}>
                        <SidebarMenuButton
                          onClick={() => navigate(path)}
                          className={isActive(path) ? "bg-muted text-primary font-medium" : "hover:bg-muted/50"}
                        >
                          <div className={`mr-2 h-3 w-3 rounded-full ${catInfo.color} shrink-0`} />
                          {!collapsed && (
                            <span className="text-xs truncate">
                              {project.id.replace('_', ' ')} — {project.name}
                            </span>
                          )}
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    );
                  })}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </>
        )}
      </SidebarContent>
    </Sidebar>
  );
}
